import { autoinject, customElement, inlineView } from 'aurelia-framework';
import { bindable } from 'aurelia-framework';
import { ReactComponent } from '~/components/react-component/react-component';
import { ApexIconReact } from './apex-icon-react';
import React from 'react';

/**
 * A component that provides Apex icons as inline svg's.
 * Actual svg declarations can be found on apex-icon-react.tsx
 */
@autoinject
@customElement('apex-icon')
@inlineView('<template ref="refContainer"></template>')
export class ApexIcon extends ReactComponent {
	@bindable name: string;

	constructor(protected element: Element) {
		super('icon', element);
	}

	protected render(): void {
		this.renderReactDOM(<ApexIconReact name={this.name} />);
	}
}
